{
    "aboutbanner.label": "{siloName} Espaces sont différents",
    "account.admin_email_notifications": "Notifications par e-mail des administrateurs",
    "account.admin_language": "Langue préférée",
    "account.admin_language_no_language": "Aucune langue",
    "account.admin_moderation_dash_settings": "Paramètres du tableau de bord de modération",
    "account.notification.email.moderationdecisions": "Décisions de modération",
    "account.notification.email.replies": "Réponses",
    "account.title": "Compte",
    "account_delete.confirm_description": "La suppression de votre profil est irréversible. Toutes les données et activités associées à votre profil peuvent prendre jusqu’à 72 heures pour être supprimées.",
    "account_delete.confirm_heading": "Êtes-vous sûr de vouloir supprimer les données de votre profil ?",
    "account_delete.description": "Sur demande, l’historique des discussions et la participation de votre compte à toute discussion sont supprimés dans le cadre de la demande. Cette action est irréversible.",
    "account_delete.heading": "Supprimer mes données",
    "account_request_data.heading": "Demander mes données",
    "account_request_data.instructions": "Envoyez un e-mail à [privacy@newpublic.org](mailto:privacy@newpublic.org) pour demander une copie de vos données associées à cet espace de discussion. Le traitement de votre demande peut prendre jusqu’à 30 jours.",
    "account_revoke_permissions.confirm_heading": "Révoquer les permissions d'administrateur de {identifier} ?",
    "account_revoke_permissions.confirm_text": "{identifier} n'aura plus les permissions d'administrateur.",
    "account_revoke_permissions.revoke_button": "Révoquer les permissions",
    "action.block": "Bloquer",
    "action.cancel": "Annuler",
    "action.create_new_voting": "Créer un nouveau vote",
    "action.delete": "Supprimer",
    "action.edit": "Modifier",
    "action.open_teaser_positioning": "Gérer les positions du teaser",
    "action.pinned": "Épinglé",
    "action.post": "Publier",
    "action.reply_to_user": "Répondre à {userName}...",
    "action.report": "Signaler",
    "action.save": "Enregistrer",
    "action.unblock": "Débloquer",
    "admin.category_analysis_heading": "Analyse",
    "admin.category_developer_tools_heading": "Outils de développement",
    "admin.category_editorial_heading": "Éditorial",
    "admin.category_moderation_heading": "Modération",
    "admin.category_owner_tools_heading": "Outils du propriétaire",
    "admin.category_starred_heading": "Étoilé",
    "admin.window_title": "Tableau de bord admin",
    "admin_mod_link.admin_users_description": "Gérer les permissions des utilisateurs administrateurs.",
    "admin_mod_link.editorial_dashboard_description": "Gérer les espaces et plus encore.",
    "admin_mod_link.editorial_dashboard_label": "Tableau de bord éditorial",
    "admin_mod_link.moderation_dashboard_description": "Modérer les discussions dans le tableau de bord refondu.",
    "admin_mod_link.ranking_eval_description": "Évaluer différents algorithmes de classement sur des conversations réelles.",
    "admin_mod_link.ranking_eval_label": "Évaluation du Classement",
    "admin_mod_link.settings_description": "Gérer les formats et fonctionnalités organisationnelles.",
    "admin_mod_link.settings_label": "Paramètres",
    "admin_mod_link.storybook_description": "Voir les composants PSI dans Storybook.",
    "admin_mod_link.storybook_label": "Storybook",
    "admin_users.add_admins_button": "Ajouter des administrateurs",
    "admin_users.add_new_admins_label": "Ajouter de nouveaux administrateurs",
    "admin_users.adding_admins_message": "Ajout d’administrateurs...",
    "admin_users.emails_placeholder": "Emails des utilisateurs à ajouter",
    "admin_users.heading": "Utilisateurs admin",
    "admin_users.loading_message": "Chargement des administrateurs...",
    "admin_users.updating_roles_message": "Mise à jour des rôles...",
    "admins.actions.edit": "Modifier",
    "admins.actions.revoke": "Révoquer les permissions",
    "admins.actions.revoke-failed": "Échec de la révocation des permissions d'administrateur de {userIdentity}",
    "admins.actions.revoked": "{userIdentity} n'a plus les permissions d'Administrateur",
    "admins.all_admins": "Tous",
    "admins.column_actions": "Actions",
    "admins.column_name": "Nom",
    "admins.column_posts": "Publications",
    "admins.column_roles": "Permissions internes",
    "admins.column_title": "Titre",
    "admins.error": "Impossible de récupérer la table des administrateurs",
    "admins.tab_label": "Profils du personnel",
    "admins.table.search": "Rechercher...",
    "admins.title": "Profils du personnel",
    "agree": "D’accord",
    "ai-helper.bullet": "👉 {tipText}",
    "ai-helper.rephrase_message": "Envisagez de reformuler votre message pour toucher un public plus large et susciter des discussions plus significatives.",
    "ai-helper.suggestions_title": "Suggestions",
    "ai-helper.tips_title": "Essayez de suivre ces conseils :",
    "aitag.ai_moderated": "Modéré par l’IA",
    "api_error.already_answered": "Vous avez déjà répondu ici. Vous pouvez modifier votre réponse à la place.",
    "api_error.bad_request": "Cela n'a pas pu être enregistré. Veuillez vérifier et réessayer.",
    "api_error.cannot_delete_default": "Le canal par défaut ne peut pas être supprimé.",
    "api_error.channel_has_spaces": "Ce canal contient encore des conversations. Déplacez-les avant de le supprimer.",
    "api_error.comment_not_found": "Nous n'avons pas pu trouver ce commentaire. Il a peut-être été supprimé.",
    "api_error.duplicate_perspective": "Deux points de vue ont le même libellé. Donnez à chacun son propre libellé.",
    "api_error.duplicate_poll_option": "\"{pollOption}\" est déjà une option.",
    "api_error.duplicate_space": "Une conversation avec cette clé existe déjà.",
    "api_error.duplicate_story": "Cette histoire a déjà été ajoutée.",
    "api_error.duplicate_term": "\"{term}\" est déjà dans la liste.",
    "api_error.empty_name": "Veuillez saisir un nom.",
    "api_error.fallback": "Une erreur s'est produite. Veuillez réessayer.",
    "api_error.feature_disabled": "Cette fonctionnalité est désactivée.",
    "api_error.forbidden": "Vous n'avez pas l'autorisation de faire cela.",
    "api_error.format_not_enabled": "Ce format n'est pas disponible ici.",
    "api_error.internal_error": "Une erreur s'est produite de notre côté. Veuillez réessayer.",
    "api_error.invalid_conversation_key": "Ceci n'est pas une clé de conversation valide.",
    "api_error.invalid_cursor": "Impossible de charger plus de contenu. Veuillez actualiser et réessayer.",
    "api_error.invalid_name": "Ce nom doit contenir au moins une lettre ou un chiffre.",
    "api_error.invalid_poll_option": "Cela ne fait pas partie des options du sondage.",
    "api_error.invalid_reaction_type": "Cette réaction n'est pas disponible dans cette conversation.",
    "api_error.invalid_role": "Ce rôle n'existe pas.",
    "api_error.invalid_space": "Nous n’avons pas pu trouver cette conversation.",
    "api_error.invalid_story_url": "Ce lien d’histoire n’est pas valide.",
    "api_error.invalid_vote": "Ce vote n’a pas pu être pris en compte. Veuillez réessayer.",
    "api_error.member_not_admin": "Seuls les administrateurs peuvent être ajoutés à un canal : {emails}",
    "api_error.moderation_mode_not_enabled": "Ce mode de modération n’est pas disponible ici.",
    "api_error.name_not_real": "Veuillez choisir un nom qui ne soit pas le nom complet d'une personne réelle.",
    "api_error.name_prohibited": "Ce nom n'est pas autorisé. Veuillez en choisir un autre.",
    "api_error.name_taken": "\"{name}\" est déjà pris. Veuillez choisir un autre nom.",
    "api_error.name_too_long": "Ce nom est trop long.",
    "api_error.name_too_short": "Ce nom est trop court.",
    "api_error.network": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
    "api_error.not_assigned": "Ce vote vidéo n’est pas encore associé à une histoire.",
    "api_error.not_found": "Nous n'avons pas pu trouver cela. Il a peut-être été supprimé.",
    "api_error.not_minor_violation": "Ce commentaire n'est pas signalé comme une infraction mineure.",
    "api_error.not_scored": "{unscored} commentaires sur {total} n'ont pas encore été évalués.",
    "api_error.opengraph_fetch_failed": "Impossible de charger un aperçu pour ce lien.",
    "api_error.order_out_of_date": "Cette liste a changé depuis que vous l’avez ouverte. Veuillez actualiser la page et réessayer.",
    "api_error.perspective_text_has_emoji": "Les points de vue ne peuvent pas contenir d'emoji.",
    "api_error.perspective_text_invalid_characters": "Un point de vue doit contenir au moins une lettre.",
    "api_error.perspective_text_too_long": "Une perspective peut contenir au maximum {maxLength} caractères.",
    "api_error.perspective_violation_not_confirmable": "Ce commentaire a été rejeté en raison de son point de vue, il ne peut donc pas être confirmé.",
    "api_error.pin_limit_reached": "Vous pouvez épingler au maximum {limit} commentaires ici. Désépinglez-en un d'abord.",
    "api_error.poll_not_enabled": "Le sondage n'est pas activé pour cette conversation.",
    "api_error.rate_limited": "Vous faites cela trop souvent. Veuillez patienter un instant et réessayer.",
    "api_error.reactions_not_enabled": "Les réactions sont désactivées pour cette conversation.",
    "api_error.related_space_limit_reached": "Vous pouvez lier au maximum {limit} conversations associées.",
    "api_error.sources_unreachable": "Impossible de joindre les sources. Veuillez réessayer plus tard.",
    "api_error.space_closed": "Cette conversation est fermée aux nouvelles contributions.",
    "api_error.space_has_comments": "Les positions du curseur ne peuvent pas être renommées une fois que des personnes ont commenté.",
    "api_error.suspended": "Votre compte est suspendu.",
    "api_error.too_many_positions": "Une histoire peut afficher son aperçu dans {maxPositions} emplacements au maximum.",
    "api_error.too_many_write_in_perspectives": "Vous ne pouvez ajouter qu’une seule perspective de votre cru.",
    "api_error.unauthorized": "Veuillez vous connecter et réessayer.",
    "api_error.unknown_source": "Cette source ne fait pas partie de celles que nous connaissons.",
    "api_error.unregistered_comment_property": "Ce commentaire n’a pas pu être enregistré. Veuillez actualiser la page et réessayer.",
    "api_error.unsupported_locale": "Ce n'est pas disponible dans votre langue.",
    "api_error.upvotes_not_enabled": "Les votes positifs sont désactivés pour cette conversation.",
    "appError.goHome": "Retourner",
    "appError.page_forbidden": "Votre compte ne peut pas accéder à cette page.",
    "appError.page_not_found": "La page que vous recherchez n'existe pas.",
    "appError.page_unauthorized": "Vous n'avez pas la permission d'accéder à cette page.",
    "article.admin_only_error": "Vous devez vous connecter en tant qu’administrateur pour voir cette écran.",
    "article.login_button": "Se connecter",
    "article.no_teaser_error": "Aucun teaser défini",
    "article.zdf_section": "Section ZDF",
    "article_teaser_position.max_positions": "Maximum de 2 positions autorisées",
    "audience_input.community_guidelines_title": "Règles de la communauté",
    "audience_input.composer_placeholder": "Exprimez-vous...",
    "audience_input.your_reply_label": "Votre réponse",
    "audience_input_template.description": "Collectez des questions, des témoignages et des histoires des utilisateurs. Cela permet une plus grande gamme d'engagement.",
    "audience_input_template.label": "Saisie du public",
    "blocklist.empty_list": "La liste noire est vide",
    "blocklist.include_alternative_spellings": "Inclure des orthographes alternatives",
    "blocklist.no_results": "Aucune entrée ne correspond à votre recherche.",
    "blocklist.only_singular_term": "Seulement le terme singulier",
    "blocklist.single_term_not_deleted": "Le terme de la liste de blocage n’a pas pu être supprimé",
    "blocklist.singular_term_tag": "Terme singulier",
    "blocklist.term_adoption_description": "Choisissez si les termes doivent être adoptés tels quels ou s'ils doivent être inclus sous forme développée.",
    "blocklist.term_required": "Un terme doit être saisi",
    "blocklist.terms_may_not_be_longer_than": "Les termes ne peuvent pas dépasser 150 caractères.",
    "blocklist.terms_not_added_duplicate": "Le terme de la liste de blocage existe déjà : {duplicateTerms}",
    "blocklist.terms_not_added_mixed": "Le terme de la liste de blocage existe déjà : {duplicateTerms}. Le terme de la liste de blocage n’a pas pu être ajouté, veuillez réessayer : {refusedTerms}",
    "blocklist.terms_not_added_refused": "Le terme de la liste de blocage n’a pas pu être ajouté, veuillez réessayer : {refusedTerms}",
    "blocklist.terms_not_deleted": "{failedCount} termes de la liste de blocage sur {totalCount} n’ont pas pu être supprimés",
    "blocklist.too_long_terms_removed": "Les termes de plus de 150 caractères ont été supprimés.",
    "button.react": "Réagir",
    "button.react_button_selected": "sélectionné",
    "button.reacted": "Réagi",
    "byline.deleted_user": "Utilisateur supprimé",
    "byline.edited": "Modifié",
    "byline.post_id": "ID :",
    "cbc_rc.profile.error_name_invalid": "Incluez uniquement des lettres, des apostrophes, des traits d'union et pas d'espaces répétés. Maximum de 50 caractères.",
    "channel_settings.title": "Paramètres du canal",
    "channels.add_channel_button": "Ajouter un canal",
    "channels.channels_label": "Canaux",
    "channels.default_channel_label": "Canal par défaut",
    "channels.delete_tooltip": "Vous ne pouvez pas supprimer le canal par défaut ni les canaux qui sont utilisés",
    "channels.image_preview": "Aperçu de l'image",
    "channels.manage_channels_heading": "Gérer les canaux",
    "channels.no_channels_available": "Aucun canal disponible",
    "channels.no_channels_available_info": "Créez et gérez des chaînes dans le tableau de bord de modération.",
    "channels.not_channel_member_warning": "Vous n'êtes pas membre du canal, certaines fonctionnalités sont désactivées !",
    "channels.select_channel": "Sélectionner un canal",
    "channels.title": "Canal",
    "close_conversation.closed_message": "Cette conversation est désormais fermée.",
    "comment.cancel_button": "Annuler",
    "comment.confirm_leave_description": "Vos changements ne seront pas enregistrés.",
    "comment.confirm_leave_heading": "Voulez-vous vraiment quitter?",
    "comment.delete_button": "Supprimer",
    "comment.delete_modal_heading": "Êtes-vous sûr de vouloir supprimer ce message ?",
    "comment.delete_modal_warning": "Cette action est irréversible.",
    "comment.edit_button": "Modifier",
    "comment.post_button": "Publier",
    "comment.posting": "Publication en cours...",
    "comment.public_comment_subtitle": "Commentaire public",
    "comment.read_more_button": "Lire la suite",
    "comment.reply_button": "Réponse",
    "comment.report_button": "Signaler",
    "comment.show_less": "Afficher moins",
    "comment.show_more_replies_plural": "Afficher {count} réponses de plus",
    "comment.show_more_reply_singular": "Afficher {count} réponse de plus",
    "comment.show_original": "Afficher l'original ({language})",
    "comment.show_translation": "Afficher la traduction ({language})",
    "comment.update_button": "Mettre à jour",
    "comment.updating": "Mise à jour...",
    "comment.your_reply_label": "Votre réponse",
    "comment_feedback.only_visible_to_you": "Visible uniquement par vous",
    "comment_slider.change_vote_button": "Mettre à jour votre réponse",
    "comment_slider.community_guidelines_title": "Règles de la communauté",
    "comment_slider.its_complicated": "C’est complexe",
    "comment_slider.no_with_reservations": "Plutôt non",
    "comment_slider.public_response": "Réponse publique",
    "comment_slider.recording_vote": "Enregistrement du vote...",
    "comment_slider.response": "réponse",
    "comment_slider.responses": "réponses",
    "comment_slider.share_thoughts": "Exprimez-vous",
    "comment_slider.skip_change_vote": "Passer et modifier le vote",
    "comment_slider.skip_submit_vote": "Sauter et voter directement",
    "comment_slider.slide_to_respond": "Faites glisser pour répondre:",
    "comment_slider.strongly_no": "Non catégorique",
    "comment_slider.strongly_yes": "Oui catégorique",
    "comment_slider.update_response": "Mettre à jour votre réponse",
    "comment_slider.yes_with_reservations": "Plutôt oui",
    "comment_slider.your_reply_label": "Votre réponse",
    "comment_slider_editable_positions.heading": "Personnaliser le curseur de commentaires",
    "comment_slider_template.description": "Demandez aux utilisateurs de répondre à votre question selon un spectre (par exemple, « Fortement non » à « Fortement oui »).",
    "comment_slider_template.label": "Curseur de commentaire",
    "common.access_denied": "Accès refusé",
    "common.are": "sont",
    "common.cancel": "Annuler",
    "common.download": "Télécharger",
    "common.is": "est",
    "common.loading": "Chargement...",
    "common.select": "Sélectionner",
    "community_guidelines.aria_popup_label": "{label} (fenêtre contextuelle)",
    "community_guidelines.category_engage_respectfully": "Engagez-vous avec respect",
    "community_guidelines.category_no_disruptive_behavior": "Pas de comportement perturbateur",
    "community_guidelines.category_no_harmful_content": "Pas de contenu nuisible",
    "community_guidelines.category_support_claims": "Soutenez vos affirmations",
    "community_guidelines.constructive_content_explanation": "**Les commentaires qui pourraient être plus constructifs** peuvent recevoir des suggestions sur la façon d'être plus cohérents avec nos normes communautaires. Vous pouvez avoir le choix de réviser votre commentaire ou de continuer à le publier tel quel. Les commentaires publiés sans révisions après avoir reçu des suggestions peuvent être classés plus bas dans le fil pour donner la priorité aux contributions plus constructives.",
    "community_guidelines.guidelines_intro": "Nos directives communautaires sont :",
    "community_guidelines.harmful_content_explanation": "**Le contenu nuisible** qui viole nos règles communautaires sera bloqué de la publication. Si cette décision a été prise par l'IA, vous pouvez faire appel de votre publication auprès d'un modérateur humain pour examen.\n\n**Les commentaires qui pourraient être plus constructifs** peuvent recevoir des suggestions sur la façon d'être plus cohérent avec nos normes communautaires. Vous pouvez avoir le choix de réviser votre commentaire ou de continuer à le publier tel quel. Les commentaires publiés sans révisions après avoir reçu des suggestions peuvent être classés plus bas dans le fil pour donner la priorité aux contributions plus constructives.",
    "community_guidelines.modal_heading": "Lignes directrices et normes communautaires",
    "community_guidelines.modal_intro": "Nous nous efforçons d'inspirer des conversations réelles, respectueuses et ouvertes dans cet espace. Tout le monde est invité à partager ses expériences ; échanger et débattre des perspectives ; et poser des questions dans un esprit de gentillesse, de connexion et de curiosité.",
    "community_guidelines.moderation_explanation": "Cet espace est conçu pour des conversations plus réfléchies que les commentaires typiques sur Internet. Notre processus de modération aide à maintenir ce standard tout en respectant votre voix et votre perspective.",
    "community_guidelines.norms_intro": "Nos normes communautaires sont :",
    "community_guidelines.rule_avoid_derogatory_labels": "Évitez les étiquettes dénigrantes",
    "community_guidelines.rule_avoid_sarcasm": "Évitez le sarcasme et les réponses méprisantes",
    "community_guidelines.rule_explain_constructively": "Expliquez les désaccords de manière constructive",
    "community_guidelines.rule_express_civility": "Exprimez vos idées avec courtoisie",
    "community_guidelines.rule_focus_on_ideas": "Concentrez-vous sur les idées, plutôt que sur les jugements de caractère",
    "community_guidelines.rule_no_illegal_content": "Pas de contenu illégal",
    "community_guidelines.rule_no_offtopic": "Pas de messages hors sujet",
    "community_guidelines.rule_no_spam": "Pas de spam ou de promotion commerciale",
    "community_guidelines.rule_no_violent_content": "Pas de contenu violent ou d’incitation à la violence",
    "community_guidelines.rule_provide_sources": "Fournissez des sources pour les affirmations factuelles",
    "community_guidelines.rule_respect_privacy": "Respectez la vie privée d’autrui, ne partagez pas d’informations personnelles",
    "community_guidelines.title": "Règles de la communauté",
    "community_guidelines.what_happens_heading": "Que se passe-t-il lorsque votre contribution viole les règles ou normes communautaires ?",
    "context_entry_points.From": "De",
    "context_entry_points.joined_from": "Rejoint depuis",
    "conversation_helper.about": "À propos de l'assistant de conversation",
    "conversation_helper.analyze_conversation": "Analyser la conversation",
    "conversation_helper.checks_performed": "- **{count} analyse(s) de conversation** réalisée(s)",
    "conversation_helper.conversation_analysis": "Analyse de la conversation",
    "conversation_helper.conversation_stats": "Statistiques de conversation",
    "conversation_helper.conversation_summary": "Résumé de la discussion",
    "conversation_helper.current_guidance": "Note d’aide actuelle",
    "conversation_helper.dashboard": "Tableau de bord de l’aide à la conversation",
    "conversation_helper.disagree": "En désaccord",
    "conversation_helper.explanation": "Explication",
    "conversation_helper.generate_new_guidance": "Générer une nouvelle note",
    "conversation_helper.generated_because": "Cette note a été générée parce que...",
    "conversation_helper.generated_by_ai": "Cette orientation est générée par l'IA.",
    "conversation_helper.guidance_messages_generated": "- **{count} note(s)** générée",
    "conversation_helper.guidance_visible_to_everyone": "Cette note est visible par tous.",
    "conversation_helper.hello_everyone": "Bonjour à tous !",
    "conversation_helper.help_history": "Historique de l’aide",
    "conversation_helper.helpful": "Utile",
    "conversation_helper.last_analysis_none": "- Dernière analyse de l’entretien: **Aucune**",
    "conversation_helper.last_analysis_time": "- Dernière analyse de l’entretien: **{time}**",
    "conversation_helper.new_comments_since_analysis": "- **{count} nouveau(x) commentaire(s)** depuis la dernière analyse",
    "conversation_helper.no_history": "Aucun historique disponible.",
    "conversation_helper.no_problems": "Aucun problème n’a été détecté.",
    "conversation_helper.problems_detected": "Problèmes détectés !",
    "conversation_helper.related_space": "Conversation associée",
    "conversation_helper.result": "Résultat: ",
    "conversation_helper.thank_you": "Merci",
    "conversation_home.about_heading": "À propos de {brandName}",
    "conversation_home.brand_name": "l'Incubateur des Espaces Publics",
    "conversation_home.citizen_conversation": "Participez à une véritable conversation",
    "conversation_home.citizen_conversation_description": "Partagez votre point de vue dans un espace conçu pour un dialogue réfléchi et constructif.",
    "conversation_home.error_loading": "Erreur lors du chargement des conversations.",
    "conversation_home.focused_topics": "Plongez dans les sujets qui vous concernent",
    "conversation_home.focused_topics_description": "Les conversations commencent par une consigne ou une question claire, permettant de garder la discussion ciblée et significative.",
    "conversation_home.hero_subtitle": "Participez à la discussion avec nos journalistes et des personnes de tout le pays.",
    "conversation_home.hero_title": "Des conversations réfléchies sur les sujets qui vous tiennent à cœur",
    "conversation_home.latest_title": "Explorez nos dernières conversations",
    "conversation_home.no_conversations": "Aucune conversation pour le moment.",
    "conversation_home.with_experts": "Connectez-vous directement avec des experts et des journalistes",
    "conversation_home.with_experts_description": "Posez des questions, approfondissez vos connaissances et engagez-vous directement avec des voix crédibles que vous appréciez.",
    "conversationhelper.ai.hint": "Pour maintenir une atmosphère accueillante et respectueuse, nous utilisons également l'IA pour soutenir la modération. Dans cette conversation, une IA donne des indices pour une atmosphère de conversation plus constructive et résume la conversation.",
    "cta_button.loading": "Chargement",
    "dashboard.table.demo.pagination": "Espaces (Paginés)",
    "dashboard.table.demo.users": "Fils de discussion",
    "date.days_abbrev": "{days}j",
    "date.hours_abbrev": "{hours}h",
    "date.minutes_abbrev": "{minutes}m",
    "date.months_abbrev": "{months}mo",
    "date.now": "maintenant",
    "date.years_abbrev": "{years}a",
    "deleted_post.author_deleted": "L'auteur a supprimé ce message.",
    "deleted_post.deleting": "Suppression…",
    "deleted_post.you_deleted": "Vous avez supprimé ce message.",
    "demo.comment": "commentaire",
    "demo.comments": "commentaires",
    "demo.count_noun": "{count} {noun}",
    "demo.disagree": "En désaccord",
    "demo.fwrd": "SUIV",
    "demo.load_video_element": "Charger l’élément vidéo",
    "demo.new_to_me": "Nouveau pour moi",
    "demo.pause": "PAUS",
    "demo.play": "LIRE",
    "demo.prev": "PRÉC",
    "demo.respect": "Respect",
    "demo.thank_you": "Merci",
    "demo.tile_admin_users_description": "Gérer les permissions des utilisateurs administrateurs.",
    "demo.tile_admin_users_label": "Utilisateurs admin",
    "demo.tile_topics_label": "Sujets",
    "developer_tools.email_testing": "Test d'email",
    "developer_tools.email_testing_description": "Envoyez un e-mail de test à l’adresse e-mail de votre compte.",
    "developer_tools.installed_versions": "Versions installées",
    "developer_tools.key": "Clé",
    "developer_tools.send_test_email": "Envoyer un email de test",
    "developer_tools.sending": "Envoi...",
    "developer_tools.test_email_sent": "E-mail de test envoyé avec succès via {provider}",
    "developer_tools.title": "Outils pour développeurs",
    "developer_tools.translation_queue": "Translation Queue",
    "developer_tools.translation_queue_description": "Process pending translation jobs for the current silo.",
    "developer_tools.translation_queue_done": "Traitement de la file de traduction terminé",
    "developer_tools.translation_queue_locked": "La file est verrouillée — un autre processus est déjà en cours.",
    "developer_tools.translation_queue_process": "Process Queue",
    "developer_tools.translation_queue_processing": "Processing...",
    "developer_tools.translation_queue_result": "Traités : {processed}, Échoués : {failed}, Ignorés : {skipped}",
    "developer_tools.translation_queue_stats": "Tâches dans la file : {total} ({pending} en attente, {failed} échouées)",
    "developer_tools.unable_to_display": "Impossible d'afficher les variables d'environnement.",
    "developer_tools.value": "Valeur",
    "developer_tools.version_client": "Client",
    "developer_tools.version_server": "Serveur",
    "developer_tools.version_unknown": "Inconnu",
    "disagree": "En désaccord",
    "editable_positions_widget.button_label": "Modifier les positions",
    "editable_positions_widget.label": "Position #{position}",
    "editorial_dash.title": "Tableau de bord éditorial",
    "editorial_experts.with-experts": "Avec les experts éditoriaux",
    "editorial_question.be_first": "Soyez le premier à partager vos réflexions",
    "editorial_question.count_noun": "{count} {noun}",
    "editorial_question.join_discussion": "Participez à la conversation",
    "editorial_question.lets_talk": "Participez à la conversation...",
    "editorial_question.response_singular": "réponse",
    "editorial_question.responses_plural": "réponses",
    "editorial_question.share_thoughts": "Exprimez-vous",
    "error.api": "Quelque chose s'est mal passé",
    "error.network": "Erreur réseau - Veuillez vérifier votre connexion à Internet et réessayer.",
    "features.srg_section": "SRG",
    "filter_list_popover.trigger_more_filters": "Plus de filtres",
    "footer.made_by": "Fait par ",
    "form.accordion.hide_details": "Masquer les détails",
    "form.accordion.show_details": "Afficher les détails",
    "form.add_button": "Ajouter",
    "form.adding_button": "Ajout en cours...",
    "form.cancel_button": "Annuler",
    "form.delete_button": "Supprimer",
    "form.edit_button": "Modifier",
    "form.other": "Autre",
    "form.remove_button": "Supprimer",
    "form.required_label": "{label} (requis)",
    "form.save_button": "Enregistrer",
    "form.uncheck_all": "Tout décocher",
    "form.update_button": "Mettre à jour",
    "format.count_noun": "{count} {noun}",
    "invite_user.button": "Inviter un utilisateur",
    "invite_user.error": "Échec de l'invitation de {email}. Veuillez réessayer.",
    "invite_user.modal.editor_subheading": "Invitez quelqu’un à devenir un [Éditeur](https://newpublic.notion.site/Technical-support-2e7fbd65fb3e80e39f11f750d0f5b129) dans les outils PSI.",
    "invite_user.modal.email_label": "Adresse e-mail",
    "invite_user.modal.heading": "Inviter un utilisateur",
    "invite_user.modal.invite_button": "Inviter",
    "invite_user.success": "{email} a été invité.",
    "language.de-CH": "Allemand (Suisse)",
    "language.de-DE": "Allemand",
    "language.en-US": "Anglais",
    "language.fr-BE": "Français (Belgique)",
    "language.fr-CA": "Français (Canada)",
    "language.fr-CH": "Français (Suisse)",
    "language.fr-FR": "Français",
    "language.it-CH": "Italien (Suisse)",
    "language.it-IT": "Italien",
    "language.nl-NL": "Néerlandais",
    "language.rm-CH": "Romanche (Suisse)",
    "legal.privacy_notice": "Avis de confidentialité",
    "legal.terms_of_service": "Conditions d'utilisation",
    "linked_partner_story.incomplete_list_banner": "Cette liste d'histoires peut être incomplète.",
    "linked_partner_story.linked_articles_description": "Voir les histoires attachées à cette conversation.",
    "linked_partner_story.linked_articles_heading": "Histoires liées",
    "linked_partner_story.no_articles_found": "Il n'y a pas encore d'histoires liées à cet espace.",
    "linked_partner_story.read_article_link": "Lire l'article",
    "linked_partner_story.view_video_link": "Voir la vidéo",
    "llm_ranking.best": "Meilleur",
    "loading": "Chargement...",
    "login.account_blocked_explanation": "Aucune action n’est nécessaire pour le bêta. Seul un Modérateur peut restaurer votre accès à la discussion.",
    "login.account_blocked_heading": "Vous ne pouvez pas vous connecter car votre compte est bloqué",
    "login.account_not_impacted": "Votre compte {siloName} n’est pas affecté et est toujours accessible.",
    "login.continue_with": "Continuer avec {providerName}",
    "login.continue_with_google": "Continuer avec Google",
    "login.cookie_notice": "🍪 Cet espace de discussion utilise uniquement des cookies essentiels. Nous n'utilisons pas de cookies à des fins publicitaires. [En savoir plus]({privacyNoticeLink}).",
    "login.default_admin_login_heading_label": "Bienvenue sur {psiBrandName}",
    "login.default_admin_login_subheading_label": "Connectez-vous avec votre compte administrateur pour commencer",
    "login.default_login_heading_label": "Un espace pour des discussions saines et des perspectives variées",
    "login.dev_login": "Connexion Dev",
    "login.logging_in": "Connexion...",
    "login.okay_button": "D’accord",
    "login.select_dev_persona": "Sélectionnez un persona de développeur",
    "login.sso_error": "Une erreur s'est produite lors de la connexion. Veuillez fermer cette fenêtre et réessayer.",
    "main.checkbox.label": "Nouvelles publications « en cours de révision »",
    "modal.cancel_button": "Annuler",
    "modal.close_button": "Fermer",
    "modal.confirm_leave_button": "Quitter",
    "moddashboard.cannot_reply": "Vous ne pouvez pas répondre à cette publication.",
    "moddashboard.cannot_reply_deleted": "Vous ne pouvez pas répondre à une publication supprimée.",
    "moddashboard.failed_to_post_reply": "Échec de la publication de la réponse",
    "moddashboard.publicly_reply_as": "Répondre publiquement en tant que",
    "moddashboard.reply_description": "Votre réponse est publiée dans l'espace de conversation et est visible par tous les utilisateurs.",
    "moddashboard.reply_posted_successfully": "Votre réponse a été publiée avec succès",
    "moddashboard.reply_to_user": "Répondre à {userName}...",
    "moddashboard.your_reply": "Votre réponse",
    "moderate_dialog.locked_name": "{name} est en train de réviser",
    "moderate_spaces.title": "Modérer les espaces",
    "moderation.admin_bypass_ai_and_manual_moderation": "Cet espace dispose d'une modération par IA et humaine activée, mais vous contournerez automatiquement les deux en tant qu'utilisateur Admin.",
    "moderation.admin_bypass_ai_moderation": "Cet espace dispose d'une modération par IA activée, mais vous la contournerez automatiquement en tant qu'utilisateur Admin.",
    "moderation.admin_bypass_flag": "Vous avez contourné un drapeau d'IA",
    "moderation.admin_bypass_manual_moderation": "Cet espace dispose d'une modération humaine activée, mais vous la contournerez automatiquement en tant qu'utilisateur Admin.",
    "moderation.admin_bypassed": "⚠️ L'IA a signalé votre réponse, mais vous l'avez automatiquement contournée en tant qu'utilisateur Admin.",
    "moderation.admin_filter_notice": "Pour contribuer à l'amélioration de la modération par l'IA, veuillez envoyer une capture d'écran de votre publication et de ce message à votre équipe.",
    "moderation.ai_and_manual_label": "Modéré par IA et manuellement",
    "moderation.ai_flag": "Drapeau IA",
    "moderation.ai_mistake_explanation": "L’IA nous aide à modérer les commentaires, mais elle peut parfois se tromper. Si l’IA vous empêche de partager une opinion respectueuse, envoyez votre commentaire à un modérateur pour examen.",
    "moderation.ai_wrong_question": "L’IA s’est-elle trompée ?",
    "moderation.approved_tag": "Approuvé",
    "moderation.automaticallyApproved": "Approuvé automatiquement",
    "moderation.awaitingDecision": "En attente de décision",
    "moderation.blocked": "Bloqué",
    "moderation.bypassedPremoderation": "Contourné la prémodération",
    "moderation.check_your_thing": "⚠️ Vérifiez votre {moderatedThing}",
    "moderation.dash.add_explanation_to_user": "Ajouter une explication à l'utilisateur",
    "moderation.dash.approve": "Approuver",
    "moderation.dash.approve_toast": "Approuvé avec succès",
    "moderation.dash.base_filter._rejected": "Rejeté manuellement",
    "moderation.dash.base_filter.auto_approved": "Approuvé automatiquement",
    "moderation.dash.base_filter.awaiting_decision": "En attente de décision",
    "moderation.dash.base_filter.bypassed_premod": "Pré-modération contournée",
    "moderation.dash.base_filter.deleted_by_user": "Supprimé par l'utilisateur",
    "moderation.dash.base_filter.manually_approved": "Approuvé manuellement",
    "moderation.dash.base_filter.my_bookmarks": "Mes favoris",
    "moderation.dash.base_filter.warnings": "Avertissements",
    "moderation.dash.block": "Bloquer",
    "moderation.dash.block_user": "Bloquer l’utilisateur",
    "moderation.dash.blocked": "Bloqué",
    "moderation.dash.blocking_info": "L'utilisateur ne pourra pas se connecter à l'espace de discussion. Un utilisateur doit être averti 2 fois avant de pouvoir être bloqué.",
    "moderation.dash.cancel_rejection": "Annuler",
    "moderation.dash.explanation_to_user": "Explication à l'utilisateur",
    "moderation.dash.feature_disabled": "Cette fonctionnalité est désactivée.",
    "moderation.dash.finish_rejecting": "Terminer le rejet",
    "moderation.dash.judgement_card.moderate": "Modérer",
    "moderation.dash.operation_error": "L’opération n’a pas pu être exécutée, veuillez réessayer",
    "moderation.dash.reject": "Rejeter",
    "moderation.dash.reject_toast": "Rejeté avec succès",
    "moderation.dash.select_all_that_apply": "Sélectionnez tout ce qui s'applique.",
    "moderation.dash.this_account_is_blocked": "🚫 Ce compte est bloqué.",
    "moderation.dash.time": "fois",
    "moderation.dash.times": "fois",
    "moderation.dash.user_already_warned": "Cet utilisateur a déjà été averti {count} {noun}.",
    "moderation.dash.user_must_be_warned_2_times": "Un utilisateur doit être averti 2 fois avant d’être bloqué.",
    "moderation.dash.user_successfully_blocked": "{user} a été bloqué avec succès",
    "moderation.dash.user_successfully_unblocked": "{user} a été débloqué avec succès",
    "moderation.dash.user_successfully_warned": "{user} a été averti avec succès",
    "moderation.dash.warn_or_block_user": "Avertir ou bloquer l'utilisateur ?",
    "moderation.dash.warn_user": "Avertir l'utilisateur",
    "moderation.dash.warning_email_info": "L'utilisateur recevra une notification par email indiquant qu'il a été averti. Vous pouvez retirer l'avertissement du compte de l'utilisateur plus tard.",
    "moderation.dash.what_guidelines_violated": "Quelles directives ce commentaire viole-t-il ?",
    "moderation.deletedByUser": "Supprimé par l'utilisateur",
    "moderation.deletedUser": "Utilisateur supprimé",
    "moderation.edit_your_post_button": "Modifier votre publication",
    "moderation.email_notification": "Vous recevrez une notification par e-mail lorsque votre publication sera approuvée ou rejetée par les modérateurs.",
    "moderation.email_notification_notice": "Vous recevrez une notification par e-mail lorsque votre publication sera approuvée ou rejetée par les modérateurs.",
    "moderation.heated": "Chaud",
    "moderation.incompatible_warning": "La révision par l’IA a déterminé que votre {moderatedThing} pourrait être incompatible avec [les règles de la communauté]($onPress) : ",
    "moderation.infoBannerLoader.label": "Examen de votre réponse...",
    "moderation.info_ai_and_manual_moderation_banner_text": "Pour maintenir un environnement accueillant et respectueux, tous les posts dans cet espace sont modérés à la fois par IA et manuellement avant publication afin de garantir qu'ils respectent les [Règles de la communauté]($onPress)",
    "moderation.info_manual_moderation_banner_text": "Pour maintenir un environnement accueillant et respectueux, tous les posts dans cet espace sont modérés manuellement avant publication afin de respecter les [Règles de la communauté]($onPress)",
    "moderation.liveThread": "Fil en direct",
    "moderation.manuallyApproved": "Approuvé manuellement",
    "moderation.manuallyRejected": "Rejeté manuellement",
    "moderation.message_to_moderator_placeholder": "Message au modérateur...",
    "moderation.mode_ai": "Modération par IA",
    "moderation.mode_ai_and_manual": "Modération par IA et manuelle",
    "moderation.mode_ai_post_anyway": "Modération par IA avec publication quand même",
    "moderation.mode_manual": "Modération manuelle",
    "moderation.new": "Nouveau",
    "moderation.perspective_label": "étiquette de perspective",
    "moderation.popular": "Populaire",
    "moderation.post_without_editing_button": "Publier sans modifier",
    "moderation.postedAnyway": "Publié quand même",
    "moderation.provide_details_help": "Fournissez tous les détails pour nous aider à déterminer si votre publication respecte nos Directives Communautaires.",
    "moderation.rejected_by_moderator": "Rejeté par un modérateur",
    "moderation.reported_by_n_users": "Signalé par {count} utilisateurs",
    "moderation.response": "réponse",
    "moderation.select_all_that_apply": "Sélectionnez toutes les options applicables.",
    "moderation.send_for_review_button": "Envoyer à un modérateur pour examen",
    "moderation.send_to_moderator_button": "Envoyer au modérateur",
    "moderation.send_to_moderator_title": "Envoyer au modérateur",
    "moderation.sending": "Envoi...",
    "moderation.sent_for_review_message": "Votre réponse a été envoyée au modérateur pour la révisée.",
    "moderation.sent_to_moderator": "Votre réponse a été envoyée au modérateur pour la révisée.",
    "moderation.sent_to_moderator_time": "Envoyé au modérateur : {time}",
    "moderation.share_details": "Partagez des détails",
    "moderation.singularTerm": "Terme singulier",
    "moderation.strict_filter_notice": "⚠️ Notre filtre de modération est actuellement réglé pour être assez strict afin d'assurer le plus haut niveau de sécurité ! Si vous pensez que votre contribution est injustement rejetée, veuillez contacter notre équipe de modération !",
    "moderation.system_unavailable_message": "Notre système de modération par IA est temporairement indisponible. Vous pouvez toujours envoyer votre publication à un modérateur humain pour examen.",
    "moderation.system_unavailable_title": "⚠️ Système de modération temporairement indisponible",
    "moderation.take_second_look_rephrase": "📢 Envisagez de reformuler votre message pour toucher un public plus large et susciter des discussions plus significatives.",
    "moderation.take_second_look_title": "Jetez un second regard",
    "moderation.take_second_look_warning": "❗️ Notre examen par IA suggère que votre réponse pourrait éloigner les personnes qui ne partagent pas votre point de vue.",
    "moderation.thank_you": "Merci !",
    "moderation.under_review": "En cours de révision",
    "moderation.update_without_editing_button": "Mettre à jour sans modifier",
    "moderation.use_ai_title": "✨ Nous utilisons l'IA pour la modération",
    "moderation.warned": "Averti",
    "moderation.what_guideline_violate": "Quelles directives ce commentaire viole-t-il ?",
    "moderation.what_happens_next": "Que se passe-t-il ensuite",
    "moderation.zdfComment": "Commentaire ZDF",
    "moderation_card.auto_translated": "Traduction automatique",
    "moderation_card.language_tag": "{locale} | Traduit",
    "moderation_card.origin": "Origine :",
    "moderation_card.origin_not_available": "Aucune origine disponible",
    "moderation_card.show_original": "Afficher l'original ({locale})",
    "moderation_card.show_translation": "Afficher la traduction ({locale})",
    "moderation_dash.add_your_notes": "Ajoutez vos notes...",
    "moderation_dash.blocklist": "Liste de blocage",
    "moderation_dash.channel_settings": "Paramètres du canal",
    "moderation_dash.community_guideline_violation": "⚠️ Violation des règles de la communauté",
    "moderation_dash.count_users": "{count} utilisateurs",
    "moderation_dash.created_by": "Créé par",
    "moderation_dash.explanation_to_user": "Explication à l’utilisateur",
    "moderation_dash.internal_notes": "Notes internes",
    "moderation_dash.manually_rejected": "Rejeté manuellement",
    "moderation_dash.message_to_moderator": "Message au modérateur",
    "moderation_dash.moderate_spaces": "Modérer les espaces",
    "moderation_dash.no_spaces": "Pas encore d'espaces",
    "moderation_dash.num_stories": "{numArticles} histoires",
    "moderation_dash.posts": "Publications",
    "moderation_dash.posts.title": "Modérer les publications",
    "moderation_dash.premod_eval_tab": "Évaluation de l'IA",
    "moderation_dash.queue.all_posts_hidden_plural": "{count} publications sont masquées par les filtres ci-dessus.",
    "moderation_dash.queue.all_posts_hidden_singular": "1 publication est masquée par les filtres ci-dessus.",
    "moderation_dash.queue.load_more": "Charger plus",
    "moderation_dash.queue.no_posts_yet": "Il n'y a pas encore de publications.",
    "moderation_dash.rejected_by": "Rejeté par",
    "moderation_dash.reported_by": "Signalé par",
    "moderation_dash.selected_community_guideline_violation": "⚠️ Violation des règles de la communauté sélectionnée",
    "moderation_dash.user_report": "Signalement d'utilisateur",
    "moderation_queue.button_filters": "Filtres",
    "moderation_queue.clear_all": "Tout effacer",
    "moderationdash.user_information": "Informations sur l'utilisateur",
    "moderationdash.user_metadata.comments_and_replies": "Publications :",
    "moderationdash.user_metadata.flagged_comments": "Publications marquées par l'IA :",
    "moderationdash.user_metadata.rejected_comments": "Publications rejetées :",
    "moderationdash.user_metadata.reported_comments": "Publications signalées :",
    "moderationdash.user_metadata.user_warnings": "Avertissements :",
    "moderationtag.manually_moderated": "Modéré manuellement",
    "most_popular.most_popular_label": "Plus populaires",
    "most_popular.most_recent_label": "Plus récents",
    "most_popular.show_more_button": "Afficher plus de réponses",
    "navigation_header.back_button": "Retour",
    "neutral": "Neutre",
    "notification.dismiss_button": "Dismiss",
    "notification.new_moderation_tasks": "Notifications concernant les nouvelles tâches de modération prêtes à être examinées",
    "notification.new_moderation_tasks_settings": "Paramètres des notifications concernant les nouvelles tâches de modération prêtes à être examinées",
    "notification.new_moderation_tasks_settings.checkboxMyChannels": "... dans mes canaux",
    "notification.new_moderation_tasks_settings.checkboxSpacesICreated": "... dans les espaces que j’ai créés",
    "notification.new_moderation_tasks_settings.checkboxSpacesIFollow": "... dans les espaces que je suis",
    "onboarding.dismiss_button": "Ignorer",
    "original_language": "Langue d'origine",
    "pagination_row.next_page": "Page suivante",
    "pagination_row.previous_page": "Page précédente",
    "pagination_row.showing": "Affichage de {start}-{end} sur {total}",
    "perspectives.add_new_perspective": "Ajouter une nouvelle perspective",
    "perspectives.add_your_own": "Ajouter votre propre",
    "perspectives.add_your_perspective": "Ajoutez votre perspective",
    "perspectives.dont_see_one": "Vous n'en voyez pas un qui convient ?",
    "perspectives.edit_invalid_characters": "Les étiquettes de perspective doivent contenir au moins une lettre",
    "perspectives.enter_label_placeholder": "Entrez une étiquette de perspective",
    "perspectives.havent_heard_yet": "Nous n’avons pas encore entendu ces perspectives",
    "perspectives.how_relate_question": "Comment vous rapportez-vous à ce problème?",
    "perspectives.poll_title": "De qui nous avons entendu parler",
    "perspectives.share_thoughts_button": "Exprimez-vous",
    "perspectives.title": "Perspectives",
    "perspectives.write_in_duplicate": "Cette perspective existe déjà — choisissez-la dans la liste",
    "perspectives.write_in_empty": "Saisissez un libellé de perspective",
    "perspectives.write_in_invalid_characters": "Les étiquettes de perspective doivent contenir au moins une lettre",
    "perspectives.write_in_no_emoji": "Les émojis ne sont pas autorisés dans les perspectives personnalisées",
    "perspectives.write_in_too_long": "Les libellés de perspective peuvent contenir au maximum {max} caractères",
    "pin_comment.feature_label": "Mettre en avant",
    "pin_comment.featured_label": "En avant",
    "pin_to_feed.move_down": "Descendre",
    "pin_to_feed.move_up": "Monter",
    "pin_to_feed.pin_label": "Épingler",
    "pin_to_feed.pinned_label": "Épinglé",
    "poll.change_vote_button": "Modifier ma réponse",
    "poll.recording_vote": "Enregistrement du vote...",
    "poll.submit_vote_button": "Soumettre",
    "poll.write_in_topic": "Rédiger un sujet...",
    "poll.you": "Vous",
    "poll_question.add_option_button": "Ajouter un choix de réponse",
    "poll_question.option_placeholder": "Écrivez votre option...",
    "poll_question.options_label": "Options du sondage",
    "poll_question.question_label": "Question du sondage",
    "poll_question.question_placeholder": "Écrivez votre question du sondage...",
    "popup.close_button": "Fermer la fenêtre",
    "popup_tip.more_information": "Plus d'informations",
    "post.post_anyway_button": "Publier quand même",
    "post.posting_anyway": "Publication quand même...",
    "post.submit": "Soumettre",
    "post.submitting": "Soumission...",
    "post.update": "Mettre à jour",
    "post.update_anyway_button": "Mettre à jour quand même",
    "post.updating": "Mise à jour...",
    "post.updating_anyway": "Mise à jour quand même...",
    "premod_review.ai_eval_title": "Évaluation de l'IA",
    "premod_review.ai_flag_label": "Drapeau IA",
    "premod_review.badge_ai_correct": "IA correcte",
    "premod_review.badge_ai_incorrect": "IA incorrecte",
    "premod_review.badge_needs_evaluation": "Nécessite une évaluation",
    "premod_review.badge_wrong_reason": "Mauvaise raison",
    "premod_review.based_on_evaluations": "Basé sur {count} évaluations \"{verdict}\"",
    "premod_review.correct_rules_label": "Règles correctes",
    "premod_review.disabled": "La collecte de données pour la révision pré-modération a été désactivée sur ce serveur. Cette fonctionnalité est activée par défaut. Pour la réactiver, retirez PREMOD_REVIEW_DISABLED=true du fichier .env.",
    "premod_review.empty_state": "Il n'y a pas de publications à évaluer dans cette catégorie.",
    "premod_review.evaluate_title": "Évaluer le drapeau IA",
    "premod_review.evaluation_correct": "L'IA a raison - la publication enfreint les directives",
    "premod_review.evaluation_incorrect": "L'IA a tort - la publication devrait être autorisée",
    "premod_review.evaluation_set_tooltip": "Nous utilisons l'IA pour générer un nouvel ensemble de publications synthétiques qui présentent les mêmes cas limites rencontrés par les véritables publications montrées ici dans les données d'évaluation.",
    "premod_review.evaluation_submitted_toast": "Votre évaluation a été soumise",
    "premod_review.evaluation_wrong_reason": "Correct de bloquer, mais pour la mauvaise raison",
    "premod_review.evaluator_explanation": "Explication de l'évaluateur",
    "premod_review.expiration_tooltip": "Les commentaires expirent après 30 jours afin de se conformer à notre politique de confidentialité.",
    "premod_review.expired": "Expiré",
    "premod_review.expires_in": "Expire dans {days}j",
    "premod_review.export_description": "Télécharger un fichier avec de vrais messages examinés de cette catégorie d'évaluation.",
    "premod_review.export_heading": "Générer des données d'évaluation pour le téléchargement",
    "premod_review.file_format_label": "Format de fichier",
    "premod_review.file_ready": "Fichier {format} prêt !",
    "premod_review.filter_ai_correct": "IA correcte",
    "premod_review.filter_ai_incorrect": "IA incorrecte",
    "premod_review.filter_needs_evaluation": "Nécessite une évaluation",
    "premod_review.filter_wrong_reason": "Mauvaise raison",
    "premod_review.format_csv": "CSV",
    "premod_review.format_json": "JSON",
    "premod_review.generate_data": "Générer des données",
    "premod_review.loading": "Chargement...",
    "premod_review.moderate_posts_description": "Donnez votre avis sur les décisions de l'IA de signaler des publications pour modération. Ce travail construit des ensembles de données d'évaluation pour améliorer la précision de la pré-modération de l'IA au fil du temps.",
    "premod_review.post_label": "Publication",
    "premod_review.reason_description": "Cela sera utilisé pour générer des données d'entraînement synthétiques pour améliorer l'IA.",
    "premod_review.reason_label": "Expliquez votre évaluation",
    "premod_review.reason_placeholder": "par exemple, \"C'est une critique légitime de la politique, pas une attaque personnelle\"",
    "premod_review.regenerate_data": "Régénérer les données",
    "premod_review.select_format": "Sélectionner le format d'exportation",
    "premod_review.select_format_description": "Choisissez un format de fichier pour votre exportation de données.",
    "premod_review.space_label": "Espace",
    "premod_review.submit": "Soumettre",
    "premod_review.submitting": "Soumission...",
    "premod_review.which_rules_violated_label": "Quelles règles ce post enfreint-il réellement ?",
    "premod_review.why_not_ai_rules_label": "Pourquoi le post ne viole-t-il pas les règles citées par l'IA ?",
    "premod_review.why_not_ai_rules_placeholder": "Expliquez pourquoi les règles citées par l'IA ne s'appliquent pas...",
    "premod_review.why_violates_label": "Pourquoi le post viole-t-il ces règles ?",
    "premod_review.why_violates_placeholder": "Expliquez pourquoi ce post viole les règles que vous avez sélectionnées...",
    "premod_review.your_evaluation": "Votre évaluation (obligatoire)",
    "profile.add_custom_name": "Ajouter un nom personnalisé",
    "profile.beta_feedback_note": "En participant à notre bêta, vous pouvez être invité à soumettre des commentaires sur votre expérience d'utilisation de ce produit.",
    "profile.collaboration_note": "Cet espace de discussion est hébergé par New_ Public, en collaboration avec {psmName}.",
    "profile.custom_photo_label": "Photo de profil personnalisée",
    "profile.edit.custom-title": "Ajouter un titre personnalisé",
    "profile.edit.custom_title": "Ajoutez un titre personnalisé",
    "profile.edit.heading": "Modifier",
    "profile.edit.name": "Nom du profil",
    "profile.edit.name_override": "Nom",
    "profile.edit.name_override.placeholder": "Ajoutez votre nom de remplacement...",
    "profile.edit.override_name_title": "Remplacer le nom du profil",
    "profile.edit.override_photo_title": "Remplacer la photo du profil",
    "profile.edit.photo": "Photo du profil",
    "profile.edit.photo_override": "URL de la photo",
    "profile.edit.photo_override.placeholder": "Ajoutez votre URL de remplacement...",
    "profile.edit.title": "Titre",
    "profile.edit.windows_title": "Modifier : {name}",
    "profile.edit_module_button": "Modifier {tLabel}",
    "profile.editorial_info": "En tant qu'utilisateur Admin, vous pouvez accéder à plus d'options pour votre profil dans le [Tableau de bord éditorial]({link}).",
    "profile.error_name_invalid": "Les noms personnalisés peuvent uniquement inclure des lettres minuscules et des chiffres.",
    "profile.error_name_looks_real": "Les noms personnalisés ne doivent pas ressembler à de vrais noms.",
    "profile.error_name_taken": "Ce nom personnalisé est déjà utilisé.",
    "profile.error_name_too_long": "Le nom personnalisé doit comporter un maximum de 50 caractères.",
    "profile.error_name_too_short": "Le nom personnalisé doit comporter au moins 3 caractères et une lettre.",
    "profile.error_name_violates": "Ce nom personnalisé est incompatible avec nos Directives Communautaires.",
    "profile.finish_button": "Terminer",
    "profile.go_to.edit": "Modifier les remplacements",
    "profile.is_titled_writer": "Est un contributeur titré",
    "profile.loading": "Chargement du profil...",
    "profile.module_name": "nom",
    "profile.module_photo_and_name": "photo et nom",
    "profile.name_label": "Nom du profil",
    "profile.no_user_error": "Aucun utilisateur de ce type",
    "profile.photo_label": "Votre photo de profil",
    "profile.photo_url_aria": "URL de la photo",
    "profile.photo_url_placeholder": "URL de la photo",
    "profile.please_wait": "Veuillez patienter...",
    "profile.public_overriden": "Vos informations ont été modifiées par un administrateur",
    "profile.setup_title": "Configurez votre profil",
    "profile.title_heading": "Titre",
    "profile.title_placeholder": "Entrer le titre",
    "profile.username_placeholder": "utilisateur123",
    "profile.warn_overriden": "Vos informations ont été modifiées par un administrateur dans le [Tableau de bord éditorial]({link}).",
    "profile_answers.admins_can_view": "Les administrateurs et les modérateurs peuvent toujours voir votre historique.",
    "profile_answers.discussion_history": "Historique des discussions",
    "profile_answers.edit_visibility": "Modifier la visibilité",
    "profile_answers.history_private": "L’historique de cet utilisateur est privé.",
    "profile_answers.load_more": "Charger plus",
    "profile_answers.rejected": "Le commentaire a été rejeté par un modérateur",
    "profile_answers.under_review": "Le commentaire est en cours d'examen",
    "profile_answers.visible_to_everyone": "Visible par tous",
    "profile_menu.dialog_label": "Menu du profil",
    "profile_menu.menu_label": "Compte",
    "prosocial_ranking.toggle_label": "Classement prosocial",
    "puppet_test_support.login_user_a": "Se connecter en tant qu'utilisateur A",
    "puppet_test_support.login_user_b": "Se connecter en tant qu'utilisateur B",
    "puppet_test_support.login_user_c": "Se connecter en tant qu'utilisateur C",
    "puppet_test_support.reset_silo": "Réinitialiser le silo de test",
    "puppet_test_support.secret_label": "Secret Puppet",
    "puppet_test_support.title": "Outils de test Puppet",
    "question.actions.close_button": "Fermer",
    "question.actions.close_confirm_button": "Fermer",
    "question.actions.close_modal_description": "Lorsqu'un espace est fermé, il devient \"en lecture seule\". La plupart des actions sont désactivées et les utilisateurs ne peuvent pas publier, répondre ou réagir. Les utilisateurs peuvent toujours signaler des commentaires. Vous pouvez rouvrir la conversation à tout moment.",
    "question.actions.close_modal_heading": "Fermer cet espace ?",
    "question.actions.edit_button": "Modifier",
    "question.actions.link_copied_toast": "Lien copié dans le presse-papiers !",
    "question.actions.linked_stories_button": "Histoires liées",
    "question.actions.preview_button": "Prévisualiser",
    "question.actions.publish_button": "Publier",
    "question.actions.publish_confirm_button": "Publier",
    "question.actions.publish_modal_description": "Une fois publié, cet espace sera visible par les utilisateurs sur votre site de production et accessible via le référencement SEO. Assurez-vous que votre contenu est prêt pour une consultation publique. Vous pouvez fermer la conversation à tout moment.",
    "question.actions.publish_modal_heading": "Publier cet espace ?",
    "question.actions.publish_success_toast": "Espace publié",
    "question.actions.reopen_button": "Réouvrir",
    "question.actions.reopen_confirm_button": "Réouvrir",
    "question.actions.reopen_modal_description": "Rouvrez cet espace pour rendre la conversation à nouveau active.",
    "question.actions.reopen_modal_heading": "Réouvrir cet espace ?",
    "question.actions.tooltip": "Plus d'options",
    "question.actions.unpublish_button": "Dépublier",
    "question.actions.unpublish_confirm_button": "Dépublier",
    "question.actions.unpublish_modal_description": "Une fois dépublié, cet espace ne sera plus visible par les utilisateurs sur votre site de production et cessera d'être indexé pour le référencement SEO. Vous pouvez republier la conversation à tout moment.",
    "question.actions.unpublish_modal_heading": "Dépublier cet espace ?",
    "question.actions.unpublish_success_toast": "Espace dépublié",
    "question.all_responses_tab": "Tous les commentaires",
    "question.conversation_format": "Format de la conversation",
    "question.conversation_helper_section": "Assistant de conversation",
    "question.conversation_type_section": "Type de conversation",
    "question.count_noun_format": "{count} {noun}",
    "question.edit_closed_banner": "Rouvrez cet espace pour le modifier.",
    "question.edit_heading": "Modifier",
    "question.edit_page_title": "Modifier: {name}",
    "question.edit_thread_header_section": "En-tête du fil de discussion",
    "question.edit_view_only_banner": "Vous pouvez consulter les paramètres de cet espace, mais pas les modifier.",
    "question.error_empty_prompt": "L'invite ne peut pas être vide.",
    "question.error_prompt_too_long": "L'invite doit comporter moins de {num} caractères.",
    "question.general_section": "Général",
    "question.input_placeholder": "Exprimez-vous...",
    "question.moderation_approach": "Approche de modération",
    "question.no_comments_message": "Soyez le premier à partager vos réflexions",
    "question.no_comments_title": "Lancez la conversation",
    "question.no_teaser_error": "Aucun teaser défini",
    "question.not_exist": "Cette question n'existe pas",
    "question.playbook_link": "Consultez le [manuel éditorial]({url}) pour obtenir des conseils.",
    "question.prompt_label": "Prompt",
    "question.prosocial_format_label": "Format prosocial",
    "question.prosocial_ranking_section": "Classement prosocial",
    "question.public_response_subtitle": "Réponse publique",
    "question.reaction_list_tooltip": "Voir les réactions",
    "question.reaction_plural": "réactions",
    "question.reaction_singular": "réaction",
    "question.reply_placeholder": "Répondre à {authorName}...",
    "question.reply_plural": "réponses",
    "question.reply_singular": "réponse",
    "question.select_format_placeholder": "Sélectionner un format",
    "question.select_moderation_placeholder": "Sélectionnez un paramètre de modération",
    "question.upvote_plural": "votes positifs",
    "question.upvote_singular": "voter positif",
    "question.your_response_title": "Votre réponse :",
    "ranking-eval.add_ranker": "Ajouter un Classeur",
    "ranking-eval.add_source": "Ajouter une source",
    "ranking-eval.back": "Retour",
    "ranking-eval.builtin_rankers_desc": "Consultez les invites des classificateurs intégrés pour référence lors de la création des vôtres.",
    "ranking-eval.builtin_rankers_title": "Classificateurs intégrés",
    "ranking-eval.cancel": "Annuler",
    "ranking-eval.cancel_edit": "Annuler",
    "ranking-eval.comment_count": "{count} commentaires",
    "ranking-eval.comment_scoring_desc": "Évaluez chaque commentaire sur une échelle de 1 à 5 étoiles",
    "ranking-eval.comments_random_order": "Commentaires dans un ordre aléatoire",
    "ranking-eval.conversation_count": "{count} conversations",
    "ranking-eval.custom_rankers_desc": "Définir des classeurs personnalisés pilotés par LLM pour une utilisation dans l'évaluation côte à côte. Les classeurs personnalisés apparaissent dans le menu déroulant des classeurs.",
    "ranking-eval.custom_rankers_title": "Classeurs Personnalisés",
    "ranking-eval.delete_ranker": "Supprimer",
    "ranking-eval.delete_source": "Supprimer",
    "ranking-eval.disabled": "(désactivé)",
    "ranking-eval.edit": "Modifier",
    "ranking-eval.edit_ranker": "Modifier le Classeur",
    "ranking-eval.edit_source": "Modifier la source",
    "ranking-eval.filter.all_sources": "Toutes les sources",
    "ranking-eval.filter_all": "Tous",
    "ranking-eval.filter_selected": "Sélectionné",
    "ranking-eval.first_pass_placeholder": "Utiliser {{question}} et {{commentText}}",
    "ranking-eval.first_pass_prompt": "Invite de Première Passe",
    "ranking-eval.imported_at": "Récupéré {time}",
    "ranking-eval.importing": "Importation de la conversation...",
    "ranking-eval.loading_ranker": "Chargement du classificateur...",
    "ranking-eval.model": "Modèle",
    "ranking-eval.model_placeholder": "Sélectionner le modèle",
    "ranking-eval.new_ranker": "Nouveau Classeur",
    "ranking-eval.new_source": "Nouvelle source",
    "ranking-eval.next_button": "Suivant →",
    "ranking-eval.no_cached": "Aucune conversation encore mise en cache. Appuyez sur \"Actualiser depuis les sources\" pour récupérer les conversations depuis les sites partenaires.",
    "ranking-eval.no_comments": "Cette conversation n'a pas de commentaires.",
    "ranking-eval.no_conversations_match": "Aucune conversation ne correspond.",
    "ranking-eval.no_conversations_to_open": "Aucune conversation pour le moment. Ajoutez des sources dans l’onglet Sources, puis appuyez sur « Actualiser à partir des sources » dans l’onglet Ensemble de conversations.",
    "ranking-eval.no_custom_rankers": "Pas encore de classeurs personnalisés. Cliquez sur \"Ajouter un Classeur\" pour en créer un.",
    "ranking-eval.no_other_ratings": "Pas encore d'autres notes.",
    "ranking-eval.no_ratings_yet": "Pas encore de notes.",
    "ranking-eval.no_sources": "Aucune source pour le moment. Cliquez sur « Ajouter une source » pour en ajouter une.",
    "ranking-eval.no_sources_to_fetch": "Aucune source pour le moment. Ajoutez les sites PSI depuis lesquels récupérer des données dans l’onglet Sources.",
    "ranking-eval.no_spaces": "Pas encore d'espaces. Ajoutez-en un ci-dessus pour commencer.",
    "ranking-eval.others_ratings": "Notes des autres",
    "ranking-eval.pick_conversation": "Choisir la conversation",
    "ranking-eval.prev_button": "← Précédent",
    "ranking-eval.ranker_col.actions": "Actions",
    "ranking-eval.ranker_col.model": "Modèle",
    "ranking-eval.ranker_col.name": "Nom",
    "ranking-eval.ranker_col.thinking": "Réflexion",
    "ranking-eval.ranker_col.topn": "Top N",
    "ranking-eval.ranker_desc_placeholder": "Brève description",
    "ranking-eval.ranker_description": "Description",
    "ranking-eval.ranker_enabled": "Activé",
    "ranking-eval.ranker_name": "Nom",
    "ranking-eval.ranker_name_placeholder": "par exemple Débat Constructif",
    "ranking-eval.ranking_scoring": "Évaluation des commentaires... {scored} sur {total}",
    "ranking-eval.ranking_selecting_top_10": "Sélection du top 10... cela peut prendre un moment",
    "ranking-eval.ranking_starting": "Démarrage du classement...",
    "ranking-eval.rating_reason_placeholder": "Pourquoi cette note ?",
    "ranking-eval.reasoning": "Niveau de réflexion",
    "ranking-eval.reasoning_placeholder": "Sélectionner le niveau",
    "ranking-eval.refresh": "Actualiser depuis les sources",
    "ranking-eval.refresh_comments": "Actualiser les commentaires",
    "ranking-eval.refresh_comments_in_progress": "Actualisation des commentaires...",
    "ranking-eval.refresh_in_progress": "Actualisation...",
    "ranking-eval.refreshing": "Récupération des conversations depuis les sites partenaires...",
    "ranking-eval.save_ranker": "Enregistrer",
    "ranking-eval.save_source": "Enregistrer",
    "ranking-eval.scoring_legend_title": "Guide de notation",
    "ranking-eval.search_conversations": "Rechercher des conversations...",
    "ranking-eval.second_pass_placeholder": "Utiliser {{question}} et {{comments}}",
    "ranking-eval.second_pass_prompt": "Invite de Seconde Passe",
    "ranking-eval.select_conversation": "Sélectionner la conversation",
    "ranking-eval.select_ranker": "Sélectionner le classificateur",
    "ranking-eval.side_by_side_desc": "Comparer deux algorithmes de classement côte à côte",
    "ranking-eval.source_base_url": "URL de base",
    "ranking-eval.source_base_url_placeholder": "p. ex. https://psi.newpublic.org",
    "ranking-eval.source_col.actions": "Actions",
    "ranking-eval.source_col.base_url": "URL de base",
    "ranking-eval.source_col.key": "Clé",
    "ranking-eval.source_col.label": "Libellé",
    "ranking-eval.source_col.silo": "Silo",
    "ranking-eval.source_key": "Clé",
    "ranking-eval.source_key_placeholder": "p. ex. np",
    "ranking-eval.source_label": "Libellé",
    "ranking-eval.source_label_placeholder": "p. ex. New Public",
    "ranking-eval.source_remote_silo": "Silo",
    "ranking-eval.source_remote_silo_placeholder": "p. ex. np",
    "ranking-eval.sources_desc": "Sites PSI depuis lesquels récupérer des conversations. L’option « Actualiser depuis les sources » dans l’onglet Ensemble de conversations les lit tous.",
    "ranking-eval.sources_title": "Sources",
    "ranking-eval.sources_unreachable": "Impossible d’atteindre {baseUrls}. Vérifiez que l’URL de base est correcte dans l’onglet Sources.",
    "ranking-eval.spaces.column_actions": "Actions",
    "ranking-eval.spaces.column_comments": "Commentaires",
    "ranking-eval.spaces.column_created": "Créé",
    "ranking-eval.spaces.column_name": "Nom",
    "ranking-eval.spaces.score_comments": "Commentaires de score",
    "ranking-eval.spaces.side_by_side": "Côte à Côte",
    "ranking-eval.spaces.title": "Espaces",
    "ranking-eval.submit_rating": "Soumettre la note",
    "ranking-eval.tab.comment_scoring": "Évaluation des Commentaires",
    "ranking-eval.tab.conversation_set": "Ensemble de Conversations",
    "ranking-eval.tab.custom_rankers": "Classeurs Personnalisés",
    "ranking-eval.tab.side_by_side": "Côte à Côte",
    "ranking-eval.tab.sources": "Sources",
    "ranking-eval.title": "Évaluation du Classement",
    "ranking-eval.top_n": "Top N",
    "ranking-eval.top_n_placeholder": "20",
    "ranking-eval.top_ten_reasoning": "Top 10 raisonnement :",
    "ranking-eval.update_rating": "Mettre à jour la note",
    "ranking-eval.view": "Voir",
    "ranking-eval.vote_a_best": "{ranker} est le meilleur",
    "ranking-eval.vote_b_best": "{ranker} est le meilleur",
    "ranking-eval.vote_tie": "Identique",
    "ranking_debug.recompute": "Recalculer le classement",
    "ranking_debug.recomputing": "Recalcul du classement…",
    "ranking_debug.toggle": "Afficher les informations de débogage du classement",
    "ranking_debug.top_ten_reasoning": "Top 10 du raisonnement :",
    "ranking_eval.show_debug_info": "Afficher les informations de débogage",
    "rating.its_complicated": "C’est complexe",
    "rating.no_with_reservations": "Plutôt non",
    "rating.strongly_no": "Non catégorique",
    "rating.strongly_yes": "Oui catégorique",
    "rating.yes_with_reservations": "Plutôt oui",
    "reaction_types.appreciation_plural": "appréciations",
    "reaction_types.appreciation_singular": "appréciation",
    "reaction_types.constructive": "Constructif",
    "reaction_types.controversial": "Controversé",
    "reaction_types.count_noun": "{count} {noun}",
    "reaction_types.default_set": "Ensemble par défaut",
    "reaction_types.empathetic": "Empathique",
    "reaction_types.enjoyable": "Appréciable",
    "reaction_types.fun_space": "Espace amusant",
    "reaction_types.funny": "Hilarant",
    "reaction_types.helpful": "Utile",
    "reaction_types.insightful": "Intéressant",
    "reaction_types.interesting": "Intéressant",
    "reaction_types.nuanced": "Nuancé",
    "reaction_types.personal_space": "Espace personnel",
    "reaction_types.playful": "Joueur",
    "reaction_types.reaction_set_label": "Ensemble de réactions",
    "reaction_types.recording": "Enregistrement de la réaction...",
    "reaction_types.relatable": "Relatable",
    "reaction_types.serious_space": "Espace sérieux",
    "reaction_types.surprising": "Surprenant",
    "reaction_types.why_appreciate": "Pourquoi appréciez-vous ce message ?",
    "related_content.add_content_button": "Ajouter du contenu",
    "related_content.article_option": "Article",
    "related_content.audio_option": "Audio",
    "related_content.invalid_url_error": "Format d'URL invalide. Veuillez entrer une URL valide.",
    "related_content.label": "Contenu connexe",
    "related_content.learn_more": "En savoir plus sur ce sujet",
    "related_content.retrieve_article_error": "Impossible de récupérer les informations de l'article. Veuillez vérifier l'URL et réessayer.",
    "related_content.show_more_button": "Afficher plus",
    "related_content.story_format_label": "Format de l'histoire",
    "related_content.story_url_label": "URL de l'histoire",
    "related_content.url_placeholder": "https://www.exemple.com",
    "related_content.video_option": "Vidéo",
    "related_conversations.add_hint": "Ajouter jusqu'à quatre espaces maximum.",
    "related_conversations.add_spaces_button": "Ajouter des espaces",
    "related_conversations.limit_reached_error": "Cet espace a déjà quatre espaces liés sélectionnés. Retirez-en un avant d'en ajouter un autre.",
    "related_conversations.next_button": "Suivant",
    "related_conversations.no_spaces_found": "Aucun espace trouvé",
    "related_conversations.participant_count": "{count} {noun}",
    "related_conversations.participant_plural": "participants",
    "related_conversations.participant_singular": "participant(e)",
    "related_conversations.previous_button": "Précédent",
    "related_conversations.title": "Conversations connexes",
    "representing_perspectives_template.description": "Demandez aux utilisateurs d’un ensemble de perspectives spécifiques de répondre à votre question.",
    "representing_perspectives_template.description_1": "Choisissez **3 à 5 perspectives spécifiques** que vous souhaitez entendre (par ex. « 🏖️ Retraité », « 📦 Nouveau résident », « 🍼 Parent qui travaille », etc.)",
    "representing_perspectives_template.description_2": "**Évitez les perspectives basées sur des données démographiques** (par ex. « urbain », « faible revenu », « femme », etc.) qui pourraient mener à des stéréotypes",
    "representing_perspectives_template.description_3": "**Évitez d'attribuer des croyances à des perspectives** (par ex. « personne ayant une attitude conservatrice », ou « partisans » et « opposants »)",
    "representing_perspectives_template.description_4": "**Choisissez un emoji** pour chaque perspective",
    "representing_perspectives_template.description_5": "Séparez les perspectives par un saut de ligne.",
    "representing_perspectives_template.form_field_label": "Perspectives",
    "representing_perspectives_template.helper_label": "Définissez vos perspectives",
    "representing_perspectives_template.label": "Représentation des perspectives",
    "representing_perspectives_template.placeholder": "Écrivez 3-5 perspectives...",
    "roles.editor": "Éditeur",
    "roles.moderator": "Modérateur",
    "roles.observer": "Observateur",
    "roles.owner": "Propriétaire",
    "roles.unknown": "Inconnu",
    "satisfaction_survey_popover.question": "De quelle satisfaction êtes-vous avec cette plateforme de conversation ?",
    "satisfaction_survey_popover.satisfied_label": "Très satisfait",
    "satisfaction_survey_popover.unsatisfied_label": "Très pas satisfait",
    "saving": "Enregistrement en cours...",
    "search.no_members_found": "Aucun membre trouvé",
    "settings.add_feature_button": "Ajouter une fonctionnalité",
    "settings.add_format_button": "Ajouter un format",
    "settings.add_to_organization_button": "Ajouter à l’organisation",
    "settings.added_button": "Ajouté",
    "settings.added_format_button": "Ajouté",
    "settings.additional_features_heading": "Fonctionnalités supplémentaires",
    "settings.ai_and_manual_moderation_description": "Exiger que tous les posts soumis par les utilisateurs passent à la fois un examen par IA et humain avant publication.",
    "settings.ai_pre_moderation_description": "Utilisez l'IA pour garantir que les posts soumis par les utilisateurs respectent les Règles de la communauté avant publication.",
    "settings.ai_pre_moderation_with_post_anyway_description": "Permettre aux utilisateurs de publier des posts que l'IA classe comme de faible qualité mais non nuisibles, et les classer plus bas dans le fil.",
    "settings.audience_input_description": "Collectez des questions, des témoignages et des histoires des utilisateurs. Cela permet une plus grande gamme d'engagement.",
    "settings.audience_input_label": "Saisie du public",
    "settings.blocklist_description": "Bloquez des mots spécifiques de tous les messages soumis par les utilisateurs.",
    "settings.channels_description": "Organisez les espaces en canaux distincts, pour permettre aux équipes éditoriales et de modération de se concentrer sur le contenu pertinent.",
    "settings.comment_slider_description": "Demandez aux utilisateurs de répondre à votre question selon un spectre (par exemple, « Fortement non » à « Fortement oui »).",
    "settings.comment_slider_label": "Curseur de commentaire",
    "settings.conversation_home": "Accueil des conversations",
    "settings.conversation_home_description": "Page publique qui présente toutes les conversations actives et fermées du silo",
    "settings.heading": "{psiBrandName} Paramètres",
    "settings.labs_description": "Formats prosociaux en phase de développement préliminaire, disponibles pour expérimentation. Les fonctionnalités des laboratoires sont pleinement fonctionnelles, mais manquent de paramètres par défaut standardisés et sont susceptibles d'évoluer au fil du temps.",
    "settings.labs_heading": "Labs",
    "settings.manual_moderation_description": "Exiger que tous les posts soumis par les utilisateurs passent un examen humain avant publication ; n'utilise pas l'IA pour la modération.",
    "settings.moderation_heading": "Modération",
    "settings.premod_review_tab_description": "Ajoutez un onglet au tableau de bord de modération où les modérateurs examinent chaque décision prise par l’IA et indiquent si elle était correcte.",
    "settings.premod_review_tab_label": "Onglet d’évaluation de l’IA",
    "settings.prosocial_formats_description": "Chaque espace de discussion est structuré selon un format guidé prosocial.",
    "settings.prosocial_formats_heading": "Formats prosociaux",
    "settings.prosocial_ranking_description": "Met automatiquement en avant les commentaires les plus pertinents et constructifs en haut du fil.",
    "settings.prosocial_ranking_label": "Classement prosocial",
    "settings.representing_perspectives_description": "Demandez aux utilisateurs d’un ensemble de perspectives spécifiques de répondre à votre question.",
    "settings.representing_perspectives_label": "Représentation des perspectives",
    "settings.stories_description": "Connectez les URL des histoires publiées aux espaces de conversation, afin qu’une conversation intégrée se charge sur les pages de votre choix. Nécessite une configuration supplémentaire par les développeurs.",
    "settings.stories_label": "Histoires",
    "settings.titled_writers_description": "Identifiez certains utilisateurs comme membres vérifiés de votre organisation lors de l'écriture de commentaires ou de réponses à d'autres.",
    "settings.titled_writers_label": "Écrivains titrés",
    "settings.video_voting_description": "Questions superposées sur le contenu vidéo.",
    "settings.video_voting_label": "Vote par vidéo",
    "simple_ranking.most_reactions": "Plus réagit",
    "simple_ranking.newest": "Plus récents",
    "single_response_help.same_question_title": "Même question, nouvel article?",
    "single_response_help.update_response_label": "Mettez à jour votre réponse avec votre nouvelle perspective.",
    "slider_with_stop_points.aria_label": "Utilisez les touches gauche et droite ou haut et bas pour ajuster le curseur",
    "sort.all": "Tout",
    "sort.ascending": "A-Z",
    "sort.most_recent": "Plus récents",
    "sort.top": "Top",
    "sort.top_voted": "Les plus votés",
    "sort_button.aria_label": "Trier par {text}",
    "sort_menu.sort_by_header": "Trier par",
    "sorting.most_recent": "Le plus récent",
    "sorting.oldest": "Plus ancien",
    "space.detail.id": "ID :",
    "space.detail.linkes.stories": "Histoires liées :",
    "space.detail.posts": "Publications :",
    "space.table.demo.name": "Nom",
    "spaces.column_actions": "Actions",
    "spaces.column_comments": "Commentaires",
    "spaces.column_created": "Créé",
    "spaces.column_creationDate": "Créé",
    "spaces.column_format": "Format",
    "spaces.column_name": "Nom",
    "spaces.column_needs_review": "Nécessite une révision",
    "spaces.column_notification_follow": "Suivre",
    "spaces.column_notification_following": "Abonné",
    "spaces.column_notifications": "Notifications",
    "spaces.column_status": "Statut",
    "spaces.draft_created": "Espace brouillon créé",
    "spaces.draft_not_created": "Erreur : espace brouillon non créé",
    "spaces.filter_active": "Actif",
    "spaces.filter_closed": "Fermé",
    "spaces.filter_draft": "Brouillon",
    "spaces.filter_heated": "Chauffé",
    "spaces.filter_needs_review": "Nécessite une révision",
    "spaces.format_required_label": "Format prosocial (requis)",
    "spaces.kickstart_conversation_tip": "Lancez cette conversation en ajoutant au moins trois commentaires.",
    "spaces.new_button": "Nouvel espace",
    "spaces.new_space_title": "Nouvel espace",
    "spaces.no_spaces_found": "Aucun espace trouvé",
    "spaces.no_spaces_yet": "Pas encore d'espaces",
    "spaces.no_templates_message": "Aucun modèle disponible",
    "spaces.prompt_help_avoid": "À éviter :",
    "spaces.prompt_help_avoid_1": "Questions suggestives",
    "spaces.prompt_help_avoid_2": "Sujets purement théoriques",
    "spaces.prompt_help_good_prompts": "De bons sujets sont :",
    "spaces.prompt_help_tip_1": "Opportuns, spécifiques, culturellement pertinents",
    "spaces.prompt_help_tip_2": "Ouverts au débat et à la discussion",
    "spaces.prompt_help_tip_3": "Clairs et ouverts, mais pas abstraits",
    "spaces.prompt_help_title": "Besoin d'aide pour écrire ?",
    "spaces.prompt_label": "Prompt",
    "spaces.prompt_placeholder": "Écrivez une question ou un prompt de discussion...",
    "spaces.status_active": "Actif",
    "spaces.status_closed": "Fermé",
    "spaces.status_draft": "Brouillon",
    "spaces.still_need_help": "Nouveau besoin d'aide?",
    "spaces.tab_label": "Fils de discussion",
    "spaces.title": "Fils de discussion",
    "spaces.visit_playbook": "Visitez le PSI Playbook",
    "srg.profile.error_name_invalid": "Les noms personnalisés peuvent uniquement inclure des lettres, des chiffres, des espaces et des tirets.",
    "standalone_question.participant": "participant",
    "standalone_question.participants": "participants",
    "status.creation_successful": "Création réussie",
    "status.edit_successful": "Modification réussie",
    "status.reload_to_see_effect": "Rechargez l'article pour voir l'effet",
    "status.reported": "Signalé",
    "story_dash.action_attach_spaces": "Associer des espaces",
    "story_dash.action_edit_spaces": "Modifier les espaces associés",
    "story_dash.action_remove": "Supprimer",
    "story_dash.action_view": "Voir l'histoire",
    "story_dash.actions_column": "Actions",
    "story_dash.add_story_button": "Ajouter une histoire",
    "story_dash.add_title": "Ajouter une histoire",
    "story_dash.attach_space_label": "Espaces",
    "story_dash.attach_space_modal_heading": "Associer des espaces",
    "story_dash.attach_spaces": "Attacher des espaces",
    "story_dash.attach_spaces_button": "Attacher des espaces",
    "story_dash.attach_spaces_description": "Associer un ou plusieurs espaces existants à cette story.",
    "story_dash.attach_spaces_modal_description": "Associer un ou plusieurs espaces existants à cette histoire.",
    "story_dash.attached_spaces_more": "+{count} de plus",
    "story_dash.cancel_button": "Annuler",
    "story_dash.connected_space_column": "Espaces connectés",
    "story_dash.create_button": "Ajouter une histoire",
    "story_dash.date_column": "Publié",
    "story_dash.domains_column": "Domaines",
    "story_dash.filter_all": "Tout",
    "story_dash.invalid_url_error": "Veuillez entrer une URL valide",
    "story_dash.name_column": "Nom",
    "story_dash.no_matches": "Aucune histoire ne correspond à votre recherche.",
    "story_dash.no_stories": "Pas encore d'histoires. Ajoutez une histoire pour commencer.",
    "story_dash.remove_confirm_button": "Supprimer",
    "story_dash.remove_modal_description": "Cette action ne peut pas être annulée. Tout espace attaché sera détaché.",
    "story_dash.remove_modal_description_2": "Vous pouvez ajouter l'histoire à nouveau à tout moment et l'attacher à un espace.",
    "story_dash.remove_modal_heading": "Supprimer cette histoire ?",
    "story_dash.save_button": "Enregistrer",
    "story_dash.search": "Rechercher...",
    "story_dash.search_placeholder": "Rechercher...",
    "story_dash.spaces_updated_toast": "Espaces mis à jour",
    "story_dash.story_added_toast": "Histoire ajoutée",
    "story_dash.story_removed_toast": "Histoire supprimée et espace(s) détaché(s)",
    "story_dash.story_url_label": "URL de l'histoire",
    "story_dash.tab": "Histoires",
    "story_dash.table_heading": "Histoires",
    "story_dash.url_description": "Ajoutez un article, une vidéo ou un autre média.",
    "story_dash.url_placeholder": "www.exemple.com",
    "strongly_agree": "Fortement d’accord",
    "strongly_disagree": "Fortement en désaccord",
    "survey.feedback_help": "Vos commentaires nous aideront à améliorer votre expérience.",
    "survey.strongly_agree": "Fortement d’accord",
    "survey.strongly_disagree": "Fortement en désaccord",
    "survey.tell_us_experience": "Parlez-nous de votre expérience",
    "survey.thank_you": "Merci d'avoir partagé votre expérience avec nous !",
    "suspension.block_user_confirm": "Bloquer {userName} ?",
    "suspension.block_user_description": "L'utilisateur ne pourra pas se connecter à l'espace de discussion.",
    "suspension.moderator_unwarned_you": "Un modérateur vous a retiré l'avertissement",
    "suspension.unblock_user_confirm": "Débloquer {userName} ?",
    "suspension.unblock_user_description": "L'utilisateur pourra à nouveau participer à l'espace de discussion.",
    "table_grid.empty": "Rien ici pour le moment",
    "tag.beta": "Bêta",
    "template.perspectives_description": "Séparez les perspectives par un saut de ligne.",
    "template.perspectives_label": "Perspectives",
    "text.character_count": "{count}/{max} caractères",
    "text.character_count_max": "{count}/{max} caractères max",
    "text.character_count_min": "{min} caractères min",
    "text.character_count_over_max": "{count}/{max} caractères max",
    "text.character_count_progress_min": "{count}/{min} caractères min",
    "tile.experimental_label": "Bêta",
    "tile.outdated_label": "Obsolète",
    "time.format": "{time}",
    "upvote.aria_label": "Vote positif",
    "upvote.count": "{count}",
    "upvote.recording": "Enregistrement du vote positif...",
    "usability_survey.easy_to_use_question": "Cette plateforme de conversation est facile à utiliser",
    "usability_survey.meets_needs_question": "Cette plateforme de conversation répond à mes besoins",
    "user.member": "Membre",
    "user_info.account_button": "Compte",
    "user_info.admin": "Admin",
    "user_info.developer_features": "Fonctionnalités pour développeurs",
    "user_info.faqs": "FAQs",
    "user_info.log_in_button": "Se connecter",
    "user_info.log_out_button": "Se déconnecter",
    "user_info.profile_button": "Profil",
    "user_info.profile_menu_aria_label": "Menu du profil pour {name}",
    "video_link.go_to_video": "Voir la vidéo",
    "video_voting.continue_button": "Continuer",
    "video_voting.create_new_voting": "Créer un nouveau vote",
    "video_voting.current_session_state": "Objet d'état de la session actuelle",
    "video_voting.deactivate_all": " tu peux désactiver cette fonction de manière générale.",
    "video_voting.edit_title": "Modifier le vote vidéo",
    "video_voting.enable_all_videos": "Activer le vote pour toutes les vidéos",
    "video_voting.enable_voting": "Autoriser le vote",
    "video_voting.intro_text": "Cette vidéo contient des questions de spectateurs auxquelles tu peux participer. Tu peux désactiver cette fonction, voter de manière anonyme et ignorer certaines questions. À propos de la ",
    "video_voting.join_discussion": "Participez à la conversation",
    "video_voting.manage_voting_admin": "Gérer les votes (Admin)",
    "video_voting.no_data_available": "Aucune donnée de vote disponible",
    "video_voting.no_main_screen": "Aucun écran principal de vote vidéo défini.",
    "video_voting.no_question_overlay": "Aucun superposition de question affichée",
    "video_voting.no_space_selected": "Sélectionnez un espace pour ce vote avant d’enregistrer.",
    "video_voting.not_logged_in_text": "Vous devez être connecté pour utiliser cette fonction.\nLa vidéo sera lue comme d’habitude et vous ne verrez pas les votes.\n**Cliquez ici pour vous connecter**.",
    "video_voting.preview_admin": "Aperçu du vote vidéo (Admin)",
    "video_voting.select_voting_for_article": "Choisir un vote pour cet article",
    "video_voting.settings": "Préférences",
    "video_voting.start_video": "Lancer la vidéo",
    "video_voting.template_missing": "Le modèle de vote vidéo est manquant",
    "video_voting.time": "Temps:",
    "video_voting.title": "Vote par vidéo",
    "video_voting.vote_anonymously": "Vote anonyme",
    "video_voting.votings_tab": "Votes",
    "video_voting.waiting_for_video": "En attente du chargement de la vidéo !",
    "video_voting.you": "Vous",
    "videoplayer_demo.pause": "PAUSE",
    "videoplayer_demo.play": "JOUER",
    "videoplayer_demo.seek_60": "ALLER À 60 SECONDES",
    "videovoting.select_chapter": "Sélectionnez un chapitre",
    "videovoting.select_existing_voting": "Sélectionnez un vote vidéo existant",
    "videovoting.select_question": "Sélectionnez une question",
    "visibility.only_visible_to_admins": "Visible uniquement par les administrateurs",
    "vote.delete_button": "Supprimer",
    "vote.delete_modal_heading": "Êtes-vous sûr de vouloir supprimer votre vote ?",
    "vote.delete_modal_warning": "Cette action est irréversible.",
    "zdf_admin.votings": "Votes",
    "zdf_article.manage_teaser_positions": "Gérer la position du teaser",
    "zdf_article.pick_positions": "Choisissez jusqu'à 2 positions",
    "zdf_article.teaser_position_last_paragraph": "Après le dernier paragraphe du texte principal",
    "zdf_article.teaser_position_second_paragraph": "Après le deuxième paragraphe du texte principal",
    "zdf_article.teaser_position_second_subheading": "Après le deuxième sous-titre du texte principal",
    "zdf_channels.all_channels_roles_access": "Les propriétaires et les éditeurs ont accès à ce canal.",
    "zdf_channels.channel_name_error": "Saisissez un nom de chaîne.",
    "zdf_channels.image_url_error": "Saisissez une URL complète de l’image, commençant par https://.",
    "zdf_videovoting.no_session": "**Aucune session initialisée**",
    "zdf_videovoting.poll_type": "Sondage",
    "zdf_videovoting.slider_type": "Curseur",
    "zdf_videovoting_editor.add_chapter": "Ajouter un chapitre",
    "zdf_videovoting_editor.add_option": "Ajouter une option",
    "zdf_videovoting_editor.add_predetermined_answer": "Ajouter une réponse prédéterminée",
    "zdf_videovoting_editor.add_question": "Ajouter une question",
    "zdf_videovoting_editor.answer_label": "Étiquette de réponse",
    "zdf_videovoting_editor.answer_value": "Valeur de réponse",
    "zdf_videovoting_editor.assign_chapter": "Attribuer un chapitre",
    "zdf_videovoting_editor.assign_space": "Attribuer un espace",
    "zdf_videovoting_editor.chapters": "Chapitres :",
    "zdf_videovoting_editor.layout": "Disposition :",
    "zdf_videovoting_editor.maximum_value": "Valeur maximale",
    "zdf_videovoting_editor.minimum_value": "Valeur minimale",
    "zdf_videovoting_editor.name": "Nom",
    "zdf_videovoting_editor.open_preview": "Ouvrir l'aperçu (debug)",
    "zdf_videovoting_editor.options": "Options",
    "zdf_videovoting_editor.prefill_data": "Préremplir les données à partir du vote existant",
    "zdf_videovoting_editor.question_name": "Nom de la question",
    "zdf_videovoting_editor.question_type": "Type de question",
    "zdf_videovoting_editor.questions": "Questions :",
    "zdf_videovoting_editor.remove_chapter": "Supprimer le chapitre",
    "zdf_videovoting_editor.selected_chapter": "Chapitre sélectionné :",
    "zdf_videovoting_editor.selected_space": "Espace sélectionné :",
    "zdf_videovoting_editor.slider_answers": "Réponses du curseur",
    "zdf_videovoting_editor.slider_options": "Options de curseur",
    "zdf_videovoting_editor.stops_video": "Arrête la vidéo",
    "zdf_videovoting_editor.timestamp": "Horodatage",
    "zdf_videovoting_editor.unit": "Unité",
    "zdf_videovoting_editor.video_info": "Infos vidéo :",
    "zdf_videovoting_editor.voting_title": "Titre du vote",
    "{count} {noun}": "{count} {noun}"
}
